import { sketchControlPoint } from "./common";
import { stopOverColor, tourColor } from "./common";

const highlightScale = ["case", ["==", ["get", "highlight"], true], 1.5, 1];

const controlPointBackground = {
  "z-index": ["get", "zIndex"],
  "circle-radius": 13,
  "circle-fill-color": "#fff",
  "circle-scale": highlightScale,
};

const controlPoint = {
  "z-index": ["get", "zIndex"],
  "circle-radius": 8,
  "circle-fill-color": "#fff",
  "circle-stroke-color": tourColor,
  "circle-stroke-width": 2,
};

const stopOverCircle = {
  "z-index": ["get", "zIndex"],
  "circle-radius": 12,
  "circle-fill-color": stopOverColor,
  "circle-scale": highlightScale,
};

const stopOverLabel = {
  "z-index": ["get", "zIndex"],
  "text-font": "600 19px 'Montserrat'",
  "text-fill-color": "#333",
  "text-value": ["get", "label"],
  "text-align": "center",
  "text-justify": "center",
  "text-baseline": "middle",
};

const stopOver = [controlPointBackground, stopOverCircle, stopOverLabel];

const firstStopOverCircle1 = {
  "z-index": ["get", "zIndex"],
  "circle-radius": 6,
  "circle-fill-color": stopOverColor,
  "circle-scale": highlightScale,
};

const firstStopOverCircle2 = {
  "z-index": ["get", "zIndex"],
  "circle-radius": 9,
  "circle-fill-color": "#fff",
  "circle-scale": highlightScale,
};

const firstStopOverCircle3 = {
  "z-index": ["get", "zIndex"],
  "circle-radius": 12,
  "circle-fill-color": stopOverColor,
  "circle-scale": highlightScale,
};

const firstStopOver = [controlPointBackground, firstStopOverCircle3, firstStopOverCircle2, firstStopOverCircle1];

const lastStopOverCircle1 = {
  "z-index": ["get", "zIndex"],
  "circle-radius": 6,
  "circle-fill-color": "#fff",
  "circle-scale": highlightScale,
};

const lastStopOverCircle2 = {
  "z-index": ["get", "zIndex"],
  "circle-radius": 12,
  "circle-fill-color": stopOverColor,
  "circle-scale": highlightScale,
};

const lastStopOver = [controlPointBackground, lastStopOverCircle2, lastStopOverCircle1];

const trackLineBackground = {
  "stroke-color": "#fff",
  "stroke-width": 10,
};

const trackLineForeground = {
  "z-index": ["get", "zIndex"],
  "stroke-color": tourColor,
  "stroke-width": 7,
};

const trackLine = [trackLineBackground, trackLineForeground];

const trackLineModifyingForeground = {
  ...trackLineForeground,
  "z-index": 100,
  "stroke-line-dash": [1, 12],
};

const trackLineModifying = [trackLineBackground, trackLineModifyingForeground];

export const shadowTrackStyle = {
  "stroke-color": "#00cc33aa",
  "stroke-width": 6,
};

export const trackStyle = [
  {
    filter: ["==", ["get", "type"], "sketch"],
    style: sketchControlPoint,
  },
  {
    filter: ["all", ["==", ["get", "type"], "controlPoint"], ["==", ["get", "stopover"], true]],
    style: stopOver,
  },
  {
    filter: [
      "all",
      ["==", ["get", "type"], "controlPoint"],
      ["==", ["get", "stopover"], true],
      ["==", ["get", "subtype"], "first"],
    ],
    style: firstStopOver,
  },
  {
    filter: [
      "all",
      ["==", ["get", "type"], "controlPoint"],
      ["==", ["get", "stopover"], true],
      ["==", ["get", "subtype"], "last"],
    ],
    style: lastStopOver,
  },
  {
    filter: ["all", ["==", ["get", "type"], "controlPoint"], ["==", ["get", "stopover"], false]],
    style: controlPoint,
  },
  {
    filter: ["all", ["==", ["get", "type"], "segment"], ["!=", ["get", "subtype"], "modifying"]],
    style: trackLine,
  },
  {
    filter: ["all", ["==", ["get", "type"], "segment"], ["==", ["get", "subtype"], "modifying"]],
    style: trackLineModifying,
  },
];
